import { defineMessages } from 'react-intl';

export default defineMessages({
  type: {
    id: 'sentinel.components.marginCallPanel.type',
    defaultMessage: 'Type',
  },
  date: {
    id: 'sentinel.components.marginCallAccordion.Date',
    defaultMessage: 'Date',
  },
  amount: {
    id: 'sentinel.components.marginCallAccordion.amount',
    defaultMessage: 'Amount',
  },
});



// WEBPACK FOOTER //
// ./src/components/MarginCallPanel/messages.js